import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEprRecyclabilityAssessmentRating implements BaseEnumType {
  private static allValues: EnumEprRecyclabilityAssessmentRating[] = []; // make sure this is top-most
  
  public static red = new EnumEprRecyclabilityAssessmentRating(0, "Red", "enum_epr_recyclability_assessment_rating_red");
  public static amber = new EnumEprRecyclabilityAssessmentRating(1, "Amber", "enum_epr_recyclability_assessment_rating_amber");
  public static green = new EnumEprRecyclabilityAssessmentRating(2, "Green", "enum_epr_recyclability_assessment_rating_green");
  public static redMedical = new EnumEprRecyclabilityAssessmentRating(3, "RedMedical", "enum_epr_recyclability_assessment_rating_red_medical");
  public static amberMedical = new EnumEprRecyclabilityAssessmentRating(4, "AmberMedical", "enum_epr_recyclability_assessment_rating_amber_medical");
  public static greenMedical = new EnumEprRecyclabilityAssessmentRating(5, "GreenMedical", "enum_epr_recyclability_assessment_rating_green_medical");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEprRecyclabilityAssessmentRating.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isRed() { return this === EnumEprRecyclabilityAssessmentRating.red; }
  public isAmber() { return this === EnumEprRecyclabilityAssessmentRating.amber; }
  public isGreen() { return this === EnumEprRecyclabilityAssessmentRating.green; }
  public isRedMedical() { return this === EnumEprRecyclabilityAssessmentRating.redMedical; }
  public isAmberMedical() { return this === EnumEprRecyclabilityAssessmentRating.amberMedical; }
  public isGreenMedical() { return this === EnumEprRecyclabilityAssessmentRating.greenMedical; }

  public static getValues(): readonly EnumEprRecyclabilityAssessmentRating[] {
    return EnumEprRecyclabilityAssessmentRating.allValues;
  }

  public static getValuesExcept0(): readonly EnumEprRecyclabilityAssessmentRating[] {
    return EnumEprRecyclabilityAssessmentRating.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEprRecyclabilityAssessmentRating {
    const found = EnumEprRecyclabilityAssessmentRating.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEprRecyclabilityAssessmentRating - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEprRecyclabilityAssessmentRating): EnumEprRecyclabilityAssessmentRating {
    const found = name ? EnumEprRecyclabilityAssessmentRating.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEprRecyclabilityAssessmentRating - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEprRecyclabilityAssessmentRating>): boolean {
    return this.key === other?.key;
  }
}